import { MarkdownEditorController, InputBase } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Markdown editor component
 * @example
 * ```html
 * <salaxy-markdown-editor ng-model="row.md"></salaxy-markdown-editor>
 * ```
 */
export class MarkdownEditor extends ComponentBase {

    /** ng-model containing markdown */
    public require = {
      model: "ngModel",
  };

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = InputBase.crudBindings;

    /** Uses the MarkdownEditorController */
    public controller = MarkdownEditorController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/form-controls/MarkdownEditor.html";
}
